// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const AlertWarning = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 19">
            <path
                fill="#D8A40F"
                d="M9 18.25a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm.844-13.5v5.625H8.156V4.75h1.688Zm-1.688 8.437V11.5h1.688v1.687H8.156Z"
            />
        </svg>
    );
};

export default React.memo(AlertWarning);
